import { allowLace } from '../../lace/allowCenterOfCrossWeb'

// クロスウェブ等の縦パーツ
export const verticalPartOfWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(587, 214, 482, 330) //左下
  ctx.quadraticCurveTo(520, 370, 520, 370) //右下
  ctx.quadraticCurveTo(658, 225, 668, 175) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  // 縦向き＿左＿外側
  ctx.moveTo(642, 143) // 上
  ctx.quadraticCurveTo(605, 230, 501, 343) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(645, 145) // 上
  ctx.quadraticCurveTo(608, 233, 505, 345) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(650, 151) // 上
  ctx.quadraticCurveTo(610, 245, 508, 351) // 下
  // // 縦向き＿右＿外側
  ctx.moveTo(652, 155) // 上
  ctx.quadraticCurveTo(613, 250, 512, 352) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartOfWeb2 = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(587, 214, 470, 340) //左下
  ctx.quadraticCurveTo(520, 370, 515, 380) //右下
  ctx.quadraticCurveTo(658, 225, 668, 175) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  // 縦向き＿左＿外側
  ctx.moveTo(642, 143) // 上
  ctx.quadraticCurveTo(605, 230, 501, 343) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(645, 145) // 上
  ctx.quadraticCurveTo(608, 233, 505, 345) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(650, 151) // 上
  ctx.quadraticCurveTo(610, 245, 508, 351) // 下
  // // 縦向き＿右＿外側
  ctx.moveTo(652, 155) // 上
  ctx.quadraticCurveTo(613, 250, 512, 352) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartOfWebWithLace = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(587, 214, 494, 311) //左下
  ctx.quadraticCurveTo(493, 353, 534, 355) //右下
  ctx.quadraticCurveTo(658, 225, 668, 175) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿外側
  ctx.moveTo(632, 125) // 上
  ctx.quadraticCurveTo(597, 205, 497, 315) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(635, 127) // 上
  ctx.quadraticCurveTo(600, 207, 502, 315) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(662, 171) // 上
  ctx.quadraticCurveTo(638, 239, 528, 347) // 下
  // 縦向き＿右＿外側
  ctx.moveTo(664, 174) // 上
  ctx.quadraticCurveTo(640, 242, 534, 349) // 下
  // 縦向き 下部の半円ステッチ＿外側
  ctx.moveTo(497, 315) // 左
  ctx.quadraticCurveTo(503, 355, 534, 349) // 右
  // // 縦向き 下部の半円ステッチ＿内側
  ctx.moveTo(502, 315) // 左
  ctx.quadraticCurveTo(505, 343, 528, 347) // 右
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  allowLace(ctx, laceColor, -2, -5, 1, 1)
  allowLace(ctx, laceColor, -19, 33, 0, 1)
  allowLace(ctx, laceColor, -34, 58, 0, 1)
  allowLace(ctx, laceColor, -53, 85, 0, 1)
  allowLace(ctx, laceColor, -73, 110, 0, 1)
}

export const verticalPartOfWebWithLaceForOutfielder = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(587, 214, 494, 311) //左下
  ctx.quadraticCurveTo(493, 353, 534, 355) //右下
  ctx.quadraticCurveTo(658, 225, 668, 175) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿外側
  ctx.moveTo(632, 125) // 上
  ctx.quadraticCurveTo(597, 205, 497, 315) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(635, 127) // 上
  ctx.quadraticCurveTo(600, 207, 502, 315) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(662, 171) // 上
  ctx.quadraticCurveTo(638, 239, 528, 347) // 下
  // 縦向き＿右＿外側
  ctx.moveTo(664, 174) // 上
  ctx.quadraticCurveTo(640, 242, 534, 349) // 下
  // 縦向き 下部の半円ステッチ＿外側
  ctx.moveTo(497, 315) // 左
  ctx.quadraticCurveTo(503, 355, 534, 349) // 右
  // // 縦向き 下部の半円ステッチ＿内側
  ctx.moveTo(502, 315) // 左
  ctx.quadraticCurveTo(505, 343, 528, 347) // 右

  ctx.moveTo(645, 143) // 左上
  ctx.quadraticCurveTo(577, 266, 535, 312) // 左下
  ctx.quadraticCurveTo(544, 314, 544, 314) // 右下
  ctx.quadraticCurveTo(605, 256, 652, 150) // 右上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  allowLace(ctx, laceColor, -12, 10, 1, 1)
  allowLace(ctx, laceColor, -30, 41)
  allowLace(ctx, laceColor, -45, 70)
  allowLace(ctx, laceColor, -65, 95)
  allowLace(ctx, laceColor, -83, 120)
}

export const verticalPartOfWebWithLaceWithJointForOutfielder = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(613, 157) //左上
  ctx.quadraticCurveTo(567, 242, 494, 311) //左下
  ctx.quadraticCurveTo(493, 353, 534, 355) //右下
  ctx.quadraticCurveTo(603, 285, 647, 209) //右上
  ctx.quadraticCurveTo(633, 178, 613, 157) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿外側
  ctx.moveTo(613, 162) // 上
  ctx.quadraticCurveTo(563, 255, 497, 313) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(616, 166) // 上
  ctx.quadraticCurveTo(570, 253, 502, 315) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(642, 205) // 上
  ctx.quadraticCurveTo(596, 284, 532, 348) // 下
  // 縦向き＿右＿外側
  ctx.moveTo(643, 209) // 上
  ctx.quadraticCurveTo(596, 289, 535, 350) // 下
  // 縦向き 下部の半円ステッチ＿外側
  ctx.moveTo(497, 315) // 左
  ctx.quadraticCurveTo(503, 355, 535, 350) // 右
  // 縦向き 下部の半円ステッチ＿内側
  ctx.moveTo(502, 315) // 左
  ctx.quadraticCurveTo(505, 346, 532, 348) // 右
  // 中央
  ctx.moveTo(626, 178) // 左上
  ctx.quadraticCurveTo(586, 260, 541, 306) // 左下
  ctx.quadraticCurveTo(547, 314, 547, 314) // 右下
  ctx.quadraticCurveTo(600, 262, 635, 189) // 右上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  allowLace(ctx, laceColor, -27, 48)
  allowLace(ctx, laceColor, -43, 70)
  allowLace(ctx, laceColor, -63, 95)
  allowLace(ctx, laceColor, -83, 120)
}

export const verticalPartOfWebWithLaceWithEdgeForDouble = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上＿外
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上＿外
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  // ctx.stroke()
  ctx.closePath()

  // laceここから
  allowLace(ctx, laceColor, -2, -10, 1, 1)
  allowLace(ctx, laceColor, -21, 28)
  allowLace(ctx, laceColor, -36, 53)
  allowLace(ctx, laceColor, -55, 80)
  allowLace(ctx, laceColor, -75, 105)
  // allowLace(ctx, laceColor, -93, 130)

  // // 縦パーツ_ヘリ革想定ここから
  ctx.beginPath()
  ctx.fillStyle = edgeColor
  ctx.moveTo(630, 120) //左上＿外
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上＿外
  ctx.quadraticCurveTo(664, 169, 664, 169) //右上＿内
  ctx.quadraticCurveTo(608, 261, 529, 349) //右下＿内
  ctx.quadraticCurveTo(497, 355, 499, 314) //左下＿内
  ctx.quadraticCurveTo(581, 215, 636, 127) //左上＿内
  ctx.quadraticCurveTo(630, 120, 630, 120) //左上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // // ヘリ革想定ここまで

  // stitchここから
  ctx.beginPath()
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // フチ＿内側
  ctx.moveTo(638, 128) // 左上
  ctx.quadraticCurveTo(569, 235, 501, 314) // 左下
  ctx.quadraticCurveTo(501, 355, 529, 346) // 右下
  ctx.quadraticCurveTo(599, 270, 662, 167) // 右上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartOfWebWithLaceWithEdge = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上＿外
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上＿外
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  // ctx.stroke()
  ctx.closePath()

  // laceここから
  allowLace(ctx, laceColor, -2, -10, 1, 1)
  allowLace(ctx, laceColor, -21, 28)
  allowLace(ctx, laceColor, -36, 53)
  allowLace(ctx, laceColor, -55, 80)
  allowLace(ctx, laceColor, -75, 105)

  // // 縦パーツ_ヘリ革想定ここから
  ctx.beginPath()
  ctx.fillStyle = edgeColor
  ctx.moveTo(630, 120) //左上＿外
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上＿外
  ctx.quadraticCurveTo(664, 169, 664, 169) //右上＿内
  ctx.quadraticCurveTo(608, 261, 529, 349) //右下＿内
  ctx.quadraticCurveTo(497, 355, 499, 314) //左下＿内
  ctx.quadraticCurveTo(581, 215, 636, 127) //左上＿内
  ctx.quadraticCurveTo(630, 120, 630, 120) //左上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // // ヘリ革想定ここまで

  // stitchここから
  ctx.beginPath()
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // フチ＿内側
  ctx.moveTo(638, 128) // 左上
  ctx.quadraticCurveTo(569, 235, 501, 314) // 左下
  ctx.quadraticCurveTo(501, 355, 529, 346) // 右下
  ctx.quadraticCurveTo(599, 270, 662, 167) // 右上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartsOfWebCircleEnd = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // フチ＿内側
  ctx.moveTo(638, 128) // 左上
  ctx.quadraticCurveTo(569, 235, 501, 314) // 左下
  ctx.quadraticCurveTo(502, 353, 529, 346) // 右下
  ctx.quadraticCurveTo(599, 270, 662, 167) // 右上
  // フチ＿外側
  ctx.moveTo(633, 124) // 左上
  ctx.quadraticCurveTo(567, 230, 497, 310)
  ctx.quadraticCurveTo(492, 358, 530, 351)
  ctx.quadraticCurveTo(607, 270, 664, 171)

  // 多分不要である
  // // 縦＿中央＿左
  // ctx.moveTo(649, 145) // 上
  // ctx.quadraticCurveTo(584, 243, 505, 337) // 下
  // // 縦＿中央＿右
  // ctx.moveTo(652, 149) // 上
  // ctx.quadraticCurveTo(579, 258, 509, 339) // 下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartsOfWebCircleEndWithEdge = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  // ctx.stroke()
  ctx.closePath()

  // // 縦パーツ_ヘリ革想定ここから
  ctx.beginPath()
  ctx.fillStyle = edgeColor
  ctx.moveTo(630, 120) //左上＿外
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(485, 365, 532, 356) //右下
  ctx.quadraticCurveTo(619, 260, 668, 176) //右上＿外
  ctx.quadraticCurveTo(664, 169, 664, 169) //右上＿内
  ctx.quadraticCurveTo(608, 261, 529, 349) //右下＿内
  ctx.quadraticCurveTo(497, 355, 499, 314) //左下＿内
  ctx.quadraticCurveTo(581, 215, 636, 127) //左上＿内
  ctx.quadraticCurveTo(630, 120, 630, 120) //左上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // // ヘリ革想定ここまで
  ctx.fillStyle = webColor

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦＿ヘリ革の内側
  ctx.moveTo(638, 128) // 左上
  ctx.quadraticCurveTo(569, 235, 501, 314) // 左下
  ctx.quadraticCurveTo(502, 353, 529, 346) // 右下
  ctx.quadraticCurveTo(599, 270, 662, 167) // 右上
  // // 縦＿中央＿左
  // ctx.moveTo(649, 145) // 上
  // ctx.quadraticCurveTo(584, 243, 505, 337) // 下
  // // 縦＿中央＿右
  // ctx.moveTo(652, 149) // 上
  // ctx.quadraticCurveTo(579, 258, 509, 339) // 下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartsOfWebCircleEndWithEdge2 = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = edgeColor
  // 縦パーツ＿ヘリ革
  ctx.beginPath()
  ctx.moveTo(638, 110) //左上
  ctx.quadraticCurveTo(573, 211, 492, 310) //左下
  ctx.quadraticCurveTo(482, 357, 532, 359) //右下
  ctx.quadraticCurveTo(619, 260, 683, 155) //右上
  ctx.quadraticCurveTo(690, 126, 676, 111) //中央上
  ctx.quadraticCurveTo(660, 91, 638, 110) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 縦パーツ_本革（ヘリ革内側）
  ctx.beginPath()
  ctx.fillStyle = webColor
  ctx.moveTo(646, 115) // 左上
  ctx.quadraticCurveTo(569, 235, 501, 314) // 左下
  ctx.quadraticCurveTo(502, 353, 529, 346) // 右下
  ctx.quadraticCurveTo(597, 270, 672, 154) // 右上
  ctx.quadraticCurveTo(677, 128, 668, 119) // 中央上
  ctx.quadraticCurveTo(657, 108, 646, 115) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革想定ここまで
  ctx.fillStyle = webColor

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  ctx.lineWidth = 1.2
  // 縦＿ヘリ革の内側
  ctx.moveTo(648, 116) // 左上
  ctx.quadraticCurveTo(571, 235, 504, 314) // 左下
  ctx.quadraticCurveTo(503, 351, 529, 344) // 右下
  ctx.quadraticCurveTo(594, 270, 670, 154) // 右上
  ctx.quadraticCurveTo(676, 134, 668, 122) // 中央上
  ctx.quadraticCurveTo(659, 109, 646, 116) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.closePath()
  // stitchここまで
}

// Vウェブの縦パーツ
export const verticalPartOfVWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ_左
  ctx.beginPath()
  ctx.moveTo(593, 83) //左上
  ctx.quadraticCurveTo(545, 176, 490, 311) //左下
  ctx.quadraticCurveTo(512, 335, 512, 335) //右下
  ctx.quadraticCurveTo(579, 205, 630, 120) //右上
  ctx.quadraticCurveTo(614, 97, 593, 83) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 縦パーツ_右
  ctx.beginPath()
  ctx.moveTo(668, 176) //左上
  ctx.quadraticCurveTo(615, 246, 514, 335) //左下
  ctx.quadraticCurveTo(538, 355, 538, 355) //右下
  ctx.quadraticCurveTo(635, 285, 689, 222) //右上
  ctx.quadraticCurveTo(681, 195, 668, 176) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  // 縦向き＿左
  // 左
  ctx.moveTo(596, 88) // 上
  ctx.quadraticCurveTo(554, 168, 495, 309) // 下
  // 右
  ctx.moveTo(625, 118) // 上
  ctx.quadraticCurveTo(573, 205, 511, 328) // 下
  // 縦向き＿左
  // 左
  ctx.moveTo(669, 183) // 上
  ctx.quadraticCurveTo(612, 257, 518, 335) // 下
  // 右
  ctx.moveTo(685, 221) // 上
  ctx.quadraticCurveTo(626, 287, 539, 348) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

// Vウェブの縦パーツ
export const verticalPartOfVWeb2 = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ_左
  ctx.beginPath()
  ctx.moveTo(606, 93) //左上
  ctx.quadraticCurveTo(542, 221, 490, 311) //左下
  ctx.quadraticCurveTo(512, 335, 512, 335) //右下
  ctx.quadraticCurveTo(575, 243, 639, 129) //右上
  ctx.quadraticCurveTo(614, 97, 606, 93) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 縦パーツ_右
  ctx.beginPath()
  ctx.moveTo(660, 160) //左上
  ctx.quadraticCurveTo(573, 247, 514, 335) //左下
  ctx.quadraticCurveTo(538, 355, 538, 355) //右下
  ctx.quadraticCurveTo(595, 283, 683, 204) //右上
  ctx.quadraticCurveTo(681, 195, 660, 160) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 左
  ctx.moveTo(609, 97) // 上
  ctx.quadraticCurveTo(550, 216, 495, 312) // 下
  // 右
  ctx.moveTo(635, 128) // 上
  ctx.quadraticCurveTo(564, 252, 512, 328) // 下
  // 左
  ctx.moveTo(659, 167) // 上
  ctx.quadraticCurveTo(575, 255, 518, 335) // 下
  // 右
  ctx.moveTo(679, 201) // 上
  ctx.quadraticCurveTo(582, 292, 537, 350) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

// Vウェブの縦パーツ
export const verticalPartOfVWeb3 = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ_左
  ctx.beginPath()
  ctx.moveTo(606, 93) //左上
  ctx.quadraticCurveTo(542, 221, 490, 311) //左下
  ctx.quadraticCurveTo(484, 328, 504, 346) //右下
  ctx.quadraticCurveTo(575, 243, 639, 129) //右上
  ctx.quadraticCurveTo(614, 97, 606, 93) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 縦パーツ_右
  ctx.beginPath()
  ctx.moveTo(660, 160) //左上
  ctx.quadraticCurveTo(573, 247, 505, 347) //左下
  ctx.quadraticCurveTo(520, 358, 538, 355) //右下
  ctx.quadraticCurveTo(595, 283, 683, 204) //右上
  ctx.quadraticCurveTo(681, 195, 660, 160) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 左
  ctx.moveTo(609, 97) // 上
  ctx.quadraticCurveTo(550, 216, 495, 312) // 下
  // 右
  ctx.moveTo(635, 128) // 上
  ctx.quadraticCurveTo(564, 252, 504, 340) // 下
  // 左
  ctx.moveTo(659, 167) // 上
  ctx.quadraticCurveTo(575, 255, 512, 345) // 下
  // 右
  ctx.moveTo(679, 201) // 上
  ctx.quadraticCurveTo(582, 292, 537, 350) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartOfWebForJoint = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(610, 161) //左上
  ctx.quadraticCurveTo(567, 242, 494, 311) //左下
  ctx.quadraticCurveTo(534, 355, 534, 355) //右下
  ctx.quadraticCurveTo(603, 285, 644, 214) //右上
  ctx.quadraticCurveTo(633, 187, 610, 161) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿外側
  ctx.moveTo(623, 179) // 上
  ctx.quadraticCurveTo(575, 267, 509, 325) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(625, 182) // 上
  ctx.quadraticCurveTo(582, 265, 514, 327) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(630, 189) // 上
  ctx.quadraticCurveTo(587, 263, 523, 327) // 下
  // 縦向き＿右＿外側
  ctx.moveTo(632, 191) // 上
  ctx.quadraticCurveTo(587, 269, 526, 329) // 下
  // 縦向き 下辺＿外側
  ctx.moveTo(499, 311) // 左
  ctx.quadraticCurveTo(535, 350, 535, 350) // 右
  // 縦向き 下辺＿内側
  ctx.moveTo(503, 307) // 左
  ctx.quadraticCurveTo(538, 346, 538, 346) // 右
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}

export const verticalPartOfWebWithLaceForJoint = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(610, 161) //左上
  ctx.quadraticCurveTo(567, 242, 494, 311) //左下
  ctx.quadraticCurveTo(493, 353, 534, 355) //右下
  ctx.quadraticCurveTo(603, 285, 644, 214) //右上
  ctx.quadraticCurveTo(633, 187, 610, 161) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿外側
  ctx.moveTo(611, 167) // 上
  ctx.quadraticCurveTo(563, 255, 497, 313) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(613, 170) // 上
  ctx.quadraticCurveTo(570, 253, 502, 315) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(639, 210) // 上
  ctx.quadraticCurveTo(596, 284, 532, 348) // 下
  // 縦向き＿右＿外側
  ctx.moveTo(641, 212) // 上
  ctx.quadraticCurveTo(596, 289, 535, 350) // 下
  // 縦向き 下部の半円ステッチ＿外側
  ctx.moveTo(497, 315) // 左
  ctx.quadraticCurveTo(503, 355, 535, 350) // 右
  // // 縦向き 下部の半円ステッチ＿内側
  ctx.moveTo(502, 315) // 左
  ctx.quadraticCurveTo(505, 346, 532, 348) // 右
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  allowLace(ctx, laceColor, -19, 33)
  allowLace(ctx, laceColor, -34, 58)
  allowLace(ctx, laceColor, -53, 85)
  allowLace(ctx, laceColor, -73, 110)
  allowLace(ctx, laceColor, -90, 130)
}
